export const initialState = {
  like: false,
  likeSuccess: false,
  likeError: null,

  unLike: false,
  unLikeSuccess: false,
  unLikeError: null,

  create: false,
  createSuccess: false,
  createError: null,

  model: null,
  replyId: null,
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "COMMENT_LIKE":
      return {
        ...state,
        like: true,
        likeSuccess: false,
        likeError: null,

        model: action.data,
      };

    case "COMMENT_LIKE_FULFILLED":
      return {
        ...state,
        like: false,
        likeSuccess: true,

        model: action.data.data,
      };

    case "COMMENT_LIKE_REJECTED":
      return {
        ...state,
        like: false,
        likeSuccess: false,
        likeError: action.data,
      };

    case "COMMENT_UNLIKE":
      return {
        ...state,
        unLike: true,
        unLikeSuccess: false,
        unLikeError: null,

        model: action.data,
      };

    case "COMMENT_UNLIKE_FULFILLED":
      return {
        ...state,
        unLike: false,
        unLikeSuccess: true,

        model: action.data.data,
      };

    case "COMMENT_UNLIKE_REJECTED":
      return {
        ...state,
        unLike: false,
        unLikeSuccess: false,
        unLikeError: action.data,
      };

    case "COMMENT_CREATE":
      return {
        ...state,
        create: true,
        createSuccess: false,
        createError: null,
        replyId: action.data.reply_id,
      };

    case "COMMENT_CREATE_FULFILLED":
      return {
        ...state,
        create: false,
        createSuccess: true,

        model: action.data,
      };

    case "COMMENT_CREATE_REJECTED":
      return {
        ...state,
        create: false,
        createSuccess: false,
        createError: action.data,
      };

    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
